<template>
  <v-dialog
      width="800"
      v-model="dialog"
  >
    <v-card>
      <v-btn icon small @click="close" absolute right class="mt-4">
        <v-icon small>fas fa-times</v-icon>
      </v-btn>
      <v-card-text v-if="info">
        <v-card-title>Пенсия и пособия</v-card-title>
        <v-simple-table dense>
          <tbody>
          <tr>
            <td>Имя</td>
            <td>{{ info.namelatin }}</td>
          </tr>
          <tr>
            <td>Фамилия</td>
            <td>{{ info.surnamelatin }}</td>
          </tr>
          <tr>
            <td>Адрес</td>
            <td>{{ info.address }}</td>
          </tr>
          <tr>
            <td>Паспорт</td>
            <td>{{ info.document }}</td>
          </tr>
          <tr>
            <td>Стаж</td>
            <td>{{ info.experience }}</td>
          </tr>
          <tr>
            <td>Дата начала действия пенсии</td>
            <td>{{ info.datepens }}</td>
          </tr>
          <tr>
            <td>Сумма</td>
            <td>{{ info.summa }}</td>
          </tr>
          </tbody>
        </v-simple-table>
      <hr>
        <v-data-table
            disable-filtering
            disable-sort
            hide-default-footer
            disable-pagination
            :headers="benefitDataHeaders"
            :items="benefitData"
        >
          <template #item.summa="{item:{summa}}">{{summa|money}}</template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>
export default {
  name: 'KatmBenefitInfoDialog',
  data() {
    return {
      dialog: false,
      info: null,
      benefitDataHeaders: [
        {
          text: 'Дата',
          value: 'period'
        },
        {
          text: 'Месяц',
          value: 'month'
        },
        {
          text: 'Сумма',
          value: 'summa'
        },
      ],
      benefitData: []
    }
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.info = null
        this.benefitData = []
      }
    }
  },
  methods: {
    close() {
      this.dialog = false
    },
    open(data) {
      this.info = data.data
      this.benefitData = data.row
      this.dialog = true
    }
  }

}
</script>